import React from "react";
import { Wrapper, TextAreaElement, Label } from "./styled.js";

export const TextArea = ({label, placeholder, required,
                             value, onChange, error, ...props}) =>
    <Wrapper>
        { label && <Label required={required}>{label}</Label>}
        <TextAreaElement
            {...props}
            placeholder={placeholder}
            required={required}
            value={value}
            onChange={e => {
                if (!onChange) {
                    return;
                }
                onChange(e.target.value);
            }}
            data-error={Boolean(error)}
        />
    </Wrapper>;

export default TextArea;
